import React from 'react';
import { Role } from '../types/commission';
import { stepShortLabel } from '../utils/commission';
interface CompensationLadderProps {
  tiers: Role[];
  currentRoleId: string;
  activeStepIndex: number;
}

/** Total BPS per funded loan at every production tier × unit step. */
export function CompensationLadder({
  tiers,
  currentRoleId,
  activeStepIndex
}: CompensationLadderProps) {
  const columns = tiers[0].steps.slice(1).map(step => `${stepShortLabel(step)} units`);
  return <section aria-labelledby="ladder-heading" className="rounded-xl border border-slate-200 bg-white shadow-card" data-id="element-214" data-mp="15ckgdp4kaagj">
      <div className="border-b border-slate-200 p-6" data-id="element-215" data-mp="1j3z1q2lxynqr">
        <h2 id="ladder-heading" className="text-base font-bold text-slate-900" data-id="element-216" data-mp="1j5trbu85r416">
          Compensation ladder
        </h2>
        <p className="mt-0.5 text-sm text-slate-500" data-id="element-217" data-mp="1t1n9pu8k5rqv">
          Total BPS paid per funded loan at each tier and unit level. Reaching a step re-rates every payment in the pay
          period.
        </p>
      </div>
      <div className="overflow-x-auto" data-id="element-218" data-mp="alo4kd907skd">
        <table className="w-full min-w-[640px] text-sm" data-id="element-219" data-mp="amz420vf2e5o">
          <thead data-id="element-220" data-mp="fjfrstypeqi8">
            <tr className="border-b border-slate-200 bg-slate-50 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-221" data-mp="fl0mqkoxkbgm">
              <th scope="col" className="px-6 py-3 text-left" data-id="element-222" data-mp="klex49e07xht">
                Tier
              </th>
              <th scope="col" className="px-6 py-3 text-right" data-id="element-223" data-mp="oit4dvi4jv76">
                Base
              </th>
              {columns.map(column => <th key={column} scope="col" className="px-6 py-3 text-right" data-id="element-224" data-mp="yibme6eh56wl">
                  {column}
                </th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-225" data-mp="188n1mp3lz2is">
            {tiers.map((tier, tierIndex) => {
            const isCurrent = tier.id === currentRoleId;
            return <tr key={tier.id} className={isCurrent ? 'bg-brand-50' : undefined} data-id="element-226" data-mp="1h9kviekc1tnn" data-mpi={tierIndex}>
                  <th scope="row" className="px-6 py-3.5 text-left font-semibold text-slate-900" data-id="element-227" data-mp="1h7i9s6q7qmoq">
                    <span className="flex items-center gap-2.5" data-id="element-228" data-mp="3dan01j1l6wx6">
                      <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-bold text-slate-500" data-id="element-229" data-mp="39cffed405bgp">
                        L{tierIndex + 1}
                      </span>
                      {tier.name}
                      {isCurrent ? <span className="rounded-full bg-brand-700 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white" data-id="element-230" data-mp="v2je9vu9syx">
                          You
                        </span> : null}
                    </span>
                  </th>
                  {tier.steps.map((step, stepIndex) => {
                const isActiveCell = isCurrent && stepIndex === activeStepIndex;
                return <td key={step.minUnits} className={`px-6 py-3.5 text-right tabular-nums ${isActiveCell ? 'font-bold text-brand-800' : 'text-slate-700'}`} data-id="element-231" data-mp="2bnvwd015fqw1" data-mpi={stepIndex}>
                        {isActiveCell ? <span className="rounded-md bg-white px-2 py-1 ring-1 ring-brand-200" data-id="element-232" data-mp="r75wg0wipxcw">{step.totalBps}</span> : step.totalBps}
                      </td>;
              })}
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </section>;
}